import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@schibsted-svp/react-ui';
import { pick } from 'lodash';

import { CenteredSpinner } from '../components/CenteredSpinner/CenteredSpinner';
import { ContainerHeader } from '../components/Container/ContainerHeader/ContainerHeader';
import { UserForm } from '../components/UserForm/UserForm';
import { useUser } from '../hooks/useUser';
import { createUser, updateUser } from '../services/api/users';
import { withFetchStatus } from '../services/notifier';

import type { FC } from 'react';
import type { UserResponse } from '../types';

export const User: FC = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({} as UserResponse);

  const { userId } = useParams<{ userId: string }>();

  const {
    data: entity,
    isFetching,
    refetch,
  } = useUser(userId === 'new' ? undefined : userId);

  useEffect(() => {
    if (entity) {
      setUser(entity);
    }
  }, [entity]);

  async function onSubmit(data: UserResponse) {
    const userId = data.id;

    if (!userId) {
      const user = await withFetchStatus(createUser, {
        success: 'User created',
        error: 'Failed to create user',
      })(pick(data, ['firstName', 'lastName', 'email']));

      navigate(`/users/${user.id}`, { replace: true });
    } else {
      await withFetchStatus(updateUser, {
        success: 'User updated',
        error: 'Failed to update user',
      })(userId, pick(data, ['firstName', 'lastName', 'role']));
    }

    await refetch();
  }

  return (
    <Fragment>
      <ContainerHeader>
        <Link to="/users">
          <Button type="button" variant="standard">
            Back to users
          </Button>
        </Link>
      </ContainerHeader>
      {isFetching ? (
        <CenteredSpinner />
      ) : (
        <UserForm user={user} onSubmit={onSubmit} />
      )}
    </Fragment>
  );
};
